"use client";

import { Breadcrumbs } from "@heroui/react";
import { getHomePath } from "@/src/routes/routes";

interface PageBreadcrumbsProps {
    data: string[];
    link: string[];
}
export default function PageBreadcrumbs({ data, link }: PageBreadcrumbsProps) {
    return (
        <Breadcrumbs separator="/">
            <Breadcrumbs.Item className={`p-0`} href={getHomePath()}>Home</Breadcrumbs.Item>
            {data && data?.length > 0 && data?.map((item, index) => (
                <Breadcrumbs.Item className={`p-0`} key={index} href={link[index]}>{item}</Breadcrumbs.Item>
            ))}
        </Breadcrumbs>
    );
}
